module.exports = __webpack_public_path__ + "img/first.5edb59cd.svg";